export const mixins = {
    data(){
        return {}
    },
    methods: {
    backUp(){
      this.$router.back();
    },
    },
}